import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "20",
  fill: "none",
  viewBox: "0 0 21 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "16",
      height: "16",
      x: "2.486",
      y: "2",
      fill: "#DBAB00",
      rx: "2"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M8.396 13v-.715l2.644-4.117H8.501l-.055-.855h4.024l.004.761-2.524 4.07h2.586l.036.856z"
    }, null, -1)
  ])))
}
export default { render: render }